




































import { Component, Vue } from 'vue-property-decorator';
import { mdbBtn, mdbCard, mdbCardBody, mdbCardTitle, mdbCardFooter, mdbCol, mdbRow, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter } from '@folky-tools/mdbvue';

@Component({
    components: {
        mdbBtn,
        mdbCard,
        mdbCardBody,
        mdbCardTitle,
        mdbCardFooter,
        mdbCol,
        mdbRow,
        mdbModal,
        mdbModalHeader,
        mdbModalTitle,
        mdbModalBody,
        mdbModalFooter
    }
})
export default class CookieConsentWarning extends Vue {
    private showCookieConsentDialog: boolean = true;
    private cookiePath: string = '/';
    private cookieDomain: string = '';
    private cookieExpiryDays: number = 365;
    private showCookiesAndPrivacyPolicy: boolean = false;

    get cookieName(): string {
        return process.env.NODE_ENV === 'production' ? '.App.CookieConsent' : `.App.MC-${process.env.NODE_ENV}.CookieConsent`;
    }

    private async beforeMount(): Promise<any> {
        this.showCookieConsentDialog = !this.getCookie(this.cookieName);
    }

    private acceptAllCookies(): void {
        this.showCookieConsentDialog = false;
        this.setCookie(this.cookieName, 1, this.cookieExpiryDays, this.cookieDomain, this.cookiePath);
    }

    private rejectNonEssentialCookies(): void {
        this.showCookieConsentDialog = false;
        this.setCookie(this.cookieName, 0, this.cookieExpiryDays, this.cookieDomain, this.cookiePath);
    }

    private getCookie(name: string): string | undefined {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);

        return parts.length !== 2 ? undefined : parts.pop()!.split(';').shift();
    }

    private setCookie(name: string, value: number, expiryDays: number, domain: string, path: string): void {
        const exdate = new Date();
        exdate.setDate(exdate.getDate() + (expiryDays || 365));

        const cookie = [`${name}=${value}`, `expires=${exdate.toUTCString()}`, `path=${path || '/'}`];

        if (domain) {
            cookie.push(`domain=${domain}`);
        }

        document.cookie = cookie.join(';');
    }
}
